<template>
  <RouterView />
</template>

<script lang="ts" setup>
definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.title',
  },
})
</script>
